require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-contracting-agile-software-product-development-for-smes-and-enterprise-organisations.json") })
        }
      }, "path---blog-contracting-agile-software-product-development-for-smes-and-enterprise-organisations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-contracting-agile-software-product-development-for-smes-and-enterprise-organisations!./.cache/json/blog-contracting-agile-software-product-development-for-smes-and-enterprise-organisations.json
// module id = 819
// module chunks = 231608221292675